import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {first, map, startWith} from 'rxjs/operators';
import {UserService} from 'src/app/services/user-services/user.service';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgClass, NgFor, NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-city-input',
    templateUrl: './city-input.component.html',
    styleUrls: ['./city-input.component.scss'],
    standalone: true,
    imports: [NgClass, MatFormFieldModule, MatInputModule, FormsModule, MatAutocompleteModule, ReactiveFormsModule, NgxIntlTelInputModule, NgFor, MatOptionModule, NgIf, AsyncPipe, TranslateModule]
})
export class CityInputComponent implements OnInit, AfterViewInit {
  @Input() user;
  @Input() cityControl: any;
  @Input() placeholder?: any;
  @Output() onChange: any = new EventEmitter<any>();
  @Output() onManualChange: any = new EventEmitter<any>();
  @Output() hasBeenClick: any = new EventEmitter<any>();
  // wantedField takes : 'city', 'birthplace', 'studyPlace', 'livingPlace'.
  @Input() wantedField = 'city';
  @Input() showManualInput: boolean = true;


  cities;
  defaultCityControl = new UntypedFormControl();
  filteredCity: Observable<string[]>;
  isManualInput: boolean = false;

  // Style
  @Input() floatLabel: FloatLabelType = 'always';
  @Input() labelContent;
  @ViewChild('cityAddress') cityAddress;
  public showManualButton: boolean;

  constructor(
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    if(!this.cityControl){
      this.cityControl = this.defaultCityControl;
    }

    this.filteredCity = this.cityControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
  );


    switch (this.wantedField) {
      case "birthplace": {
        if (this.user.birthplace) {
          this.cityControl.setValue(this.user.birthplace);
        }
        break;
      }
      case 'studyPlace': {
        this.cityControl.setValue(this.user.studentCity);
        this.getCities('FR');
        break;
      }
      case 'livingPlace': {
        if (this.user.country) this.getCities(this.user.homeCountry_Info.alpha2Code);
        break;
      }
      default: {
        this.cityControl.setValue(this.user.city);
        this.getCities(this.user.country);
        break;
      }
    }
  }

  ngAfterViewInit() {
    if (this.wantedField === 'birthplace') {
      const autocomplete = new google.maps.places.Autocomplete(this.cityAddress.nativeElement,{
        types: ['(cities)'],
        fields: ['address_components', 'formatted_address']});
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        if(place.address_components[0].long_name !== null){
          this.onClick(place);
        }
        this.onValueChange(place);
      });
      this.cityAddress.nativeElement.addEventListener('input', () => {
        const result = this.cityAddress.nativeElement.value;
        if (result.length > 0) {
          this.getGoogleAutocomplete(result);
        }
      });
    }
  }

  getGoogleAutocomplete(query: string) {
    const service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions({ input: query, types: ['(cities)'] }, (predictions: google.maps.places.AutocompletePrediction[], status: google.maps.places.PlacesServiceStatus) => {
      this.showManualButton = status !== google.maps.places.PlacesServiceStatus.OK;
    });
  }


  _filter(value) {
    if (typeof value == 'object') {
      value = value.name;
    }
    if (value) {
      const filterCity = value.toLowerCase();
      if(this.cities && this.cities.length > 0){
        return this.cities.filter(city => city.name.toLowerCase().indexOf(filterCity) === 0);
      }
    }
  }

  getCities(country){
    this.userService.getCities(country).pipe(first()).subscribe(
      (response:any) => {
        this.cities = response;
      }
    )
  }

  onValueChange(e){
    this.onChange.emit(e);
  }

  onClick(e){
    this.hasBeenClick.emit(e);
  }

  public goManual(value): void {
    this.isManualInput = value;
    this.onManualChange.emit(value);
    this.cityControl.setValue(null);
  }

  public checkLatin(e){
    const  regex = new RegExp("^[A-zÀ-ÿ0-9- ']+$");
    if (regex.test(e.target.value)) {
      this.cityControl.setErrors(null);
      return true;
    }
    else{
      this.cityControl.setErrors({'incorrect': true});
      return false;
    }
  }

}
